var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuitability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.786 3h16.428c.433 0 .786.352.786.78v2.302H3V3.78c0-.43.354-.78.786-.78zM9.56 9.837h4.881c1.121 0 2.038.91 2.038 2.023v4.848a2.036 2.036 0 0 1-2.038 2.024H9.559a2.036 2.036 0 0 1-2.037-2.024V11.86c0-1.113.916-2.023 2.037-2.023zm-.461 5.006c-.818-.798.405-2.033 1.222-1.235l.981.955 2.372-2.38c.807-.807 2.044.413 1.236 1.22l-2.977 2.989a.876.876 0 0 1-1.232.01l-1.602-1.559zM17.91 3.818h1.509v1.499H17.91V3.818zm-11.449 0h1.51v1.499h-1.51V3.818zm-2.385 0h1.51v1.499h-1.51V3.818zM21 7.302v12.917c0 .43-.354.781-.786.781H3.786A.786.786 0 0 1 3 20.22V7.301h18z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitability);
export default __webpack_public_path__ + "static/media/suitability.12dfdd0d.svg";
export { ForwardRef as ReactComponent };